import { create } from 'zustand'
import { InventoryItem } from '../types'

interface InventoryState {
  items: InventoryItem[]
  isLoading: boolean
  error: string | null
  
  // Actions
  setItems: (items: InventoryItem[]) => void
  updateItem: (productId: string, quantity: number) => void
  loadInventory: (playerId: string) => Promise<void>
  reset: () => void
}

export const useInventoryStore = create<InventoryState>((set) => ({
  items: [],
  isLoading: false,
  error: null,
  
  setItems: (items) => set({ items, error: null }),
  
  updateItem: (productId: string, quantity: number) => {
    set((state) => ({
      items: state.items.map(item => 
        item.product_id === productId 
          ? { ...item, quantity: item.quantity + quantity }
          : item
      )
    }))
  },
  
  loadInventory: async (playerId: string) => {
    set({ isLoading: true, error: null })
    
    try {
      const response = await fetch(`https://business-tycoon-worker.smnshzh.workers.dev/api/players/${playerId}/inventory`)
      if (!response.ok) {
        throw new Error('Failed to load inventory')
      }
      
      const inventoryData: InventoryItem[] = await response.json()
      set({ items: inventoryData, isLoading: false })
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Unknown error',
        isLoading: false 
      })
    }
  },
  
  reset: () => set({ items: [], error: null, isLoading: false })
}))
